<template>
  <div class="app-main-content voucher-maintenance">
    <div class="tabs-container">
      <span style="position: absolute; right: 10px; margin-top: 5px;">
        <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
      </span>
      <business-commission-page :account-set="accountSet" />
    </div>
    <!-- 选择账套 -->
    <account-set-popup
      ref="refAccountSetPopup"
      :visible.sync="accountSetPopup.visible"
      :mode="accountSetPopup.mode"
      @select="data=>accountSet=data"
      @cancel="()=>accountSetPopup.visible=false"
    />
  </div>
</template>

<script>

import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import BusinessCommissionPage from '@/views/cargo/v0/FinanceManage/BusinessCommission/BusinessCommissionPage'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'BusinessCommissionModule',
  components: { BusinessCommissionPage, AccountSetPopup },
  data() {
    return {
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' }
    }
  },
  computed: {
    lbAccount() {
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      this.accountSetPopup.visible = true
    }
  }
}
</script>
